<template>
  <div class="booktracking-container">
    <b-col class="zone-main-title">
      <h1 class="main-title">
        BookTracking
        <span class="separator" />
      </h1>
    </b-col>
    <div id="zone_ambassade">
      <b-col class="zone-main-title">
        <h2
          class="main-title"
          :class="(isOpenAmbassades ? 'rotate active' : 'no-rotate')"
          @click="toggleAmbassades"
        >
          Ambassades
          <i class="fas fa-chevron-left" />
          <span class="separator" />
        </h2>
      </b-col>
      <template
        v-if="isOpenAmbassades"
      >
        <BookTrackingTable
          table-id="booktracking-ambassades"
          :columns="columnsAmbassades"
          :items="itemsAmbassades"
          :parsed-items="parsedItemsAmbassades"
          :error="errorAmbassades"
          :loading="loadingTableAmbassades"
          :navigation-settings="navigationSettingsAmbassades"
          :nb-pages-total="nbPagesTotalAmbassades"
          :items-per-page-options="itemsPerPageOptions"
          :disable-pagination="loadingTableAmbassades"
          :order-by="orderByAmbassades"
          :consult-button-id="consultButtonId"
          :handle-comment-tooltip-enter="handleCommentTooltipEnter"
          :comment-tooltip-state="commentTooltipState"
          :show-alert-column="isNH"
          @update-pagination="updatePaginationAmbassades"
          @open-commande="openCommande"
          @sort="sortAmbassades"
        >
          <template #comment-header="{ comment, }">
            <div class="comment-meta-row">
              <strong class="comment-meta-date">{{ formatCommentDate(comment.date_creation) }}</strong>
              <span
                class="comment-meta-type"
                :class="commentTypeClass(comment.type_commentaire)"
              >
                {{ formatCommentType(comment.type_commentaire) }}
              </span>
            </div>
            <span class="comment-meta-author">
              Auteur&nbsp;: {{ (comment.user_created && comment.user_created.username) || "Utilisateur inconnu" }}
            </span>
          </template>
        </BookTrackingTable>
      </template>
    </div>
    <div
      v-if="$store.getters.typeUser.nom === 'NH'"
      id="zone_libraire"
    >
      <b-col class="zone-main-title">
        <h2
          class="main-title"
          :class="(isOpenLibraires ? 'rotate active' : 'no-rotate')"
          @click="toggleLibraires"
        >
          Libraires
          <i class="fas fa-chevron-left" />
          <span class="separator" />
        </h2>
      </b-col>
      <template
        v-if="isOpenLibraires"
      >
        <BookTrackingTable
          table-id="booktracking-libraires"
          :columns="columns"
          :items="itemsLibraires"
          :parsed-items="parsedItemsLibraires"
          :error="errorLibraires"
          :loading="loadingTableLibraires"
          :navigation-settings="navigationSettingsLibraires"
          :nb-pages-total="nbPagesTotalLibraires"
          :items-per-page-options="itemsPerPageOptions"
          :disable-pagination="loadingTableLibraires"
          :order-by="orderByLibraires"
          :consult-button-id="consultButtonId"
          :handle-comment-tooltip-enter="handleCommentTooltipEnter"
          :comment-tooltip-state="commentTooltipState"
          :show-alert-column="false"
          @update-pagination="updatePaginationLibraires"
          @open-commande="openCommande"
          @sort="sortLibraires"
        >
          <template #comment-header="{ comment, }">
            <div class="comment-meta-row">
              <strong class="comment-meta-date">{{ formatCommentDate(comment.date_creation) }}</strong>
              <span
                class="comment-meta-type"
                :class="commentTypeClass(comment.type_commentaire)"
              >
                {{ formatCommentType(comment.type_commentaire) }}
              </span>
            </div>
            <span class="comment-meta-author">
              Auteur&nbsp;: {{ (comment.user_created && comment.user_created.username) || "Utilisateur inconnu" }}
            </span>
          </template>
        </BookTrackingTable>
      </template>
    </div>
    <AmbassadeModal />
    <LibraireModal />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Api from "@/modules/axios";
import LibraireModal from "@/components/libraires/LibraireModal.vue";
import AmbassadeModal from "@/components/ambassades/AmbassadeModal.vue";
import BookTrackingTable from "@/components/commandes/booktracking/BookTrackingTable.vue";

import { formatDateFR } from "@/modules/utils";

export default {
  name: "BookTracking",
  components: {
    LibraireModal,
    AmbassadeModal,
    BookTrackingTable,
  },
  data() {
    return {
      // Libraires
      isOpenLibraires: false,
      navigationSettingsLibraires: {
        pageActuelle: 1,
        limiteActuelle: 25,
      },
      nbPagesTotalLibraires: 1,
      itemsTotalLibraires: 0,
      itemsLibraires: [],
      orderByLibraires: "-date",
      filtersLibraires: [],
      errorLibraires: null,
      loadingTableLibraires: true,
      // Ambassades
      isOpenAmbassades: false,
      navigationSettingsAmbassades: {
        pageActuelle: 1,
        limiteActuelle: 25,
      },
      nbPagesTotalAmbassades: 1,
      itemsTotalAmbassades: 0,
      itemsAmbassades: [],
      orderByAmbassades: "-date",
      filtersAmbassades: [],
      errorAmbassades: null,
      loadingTableAmbassades: true,
      // Commun
      itemsPerPageOptions: [25, 50, 100],
      columns: [
        {
          sort_key: "id_lde",
          verbose_name: "ID LDE",
          val(row) {
            return row.id_lde;
          },
        },
        {
          sort_key: "numero",
          verbose_name: "Numéro",
          val(row) {
            return row.numero;
          },
        },
        {
          sort_key: "date",
          verbose_name: "Création",
          val(row) {
            return row.date_commande;
          },
        },
        {
          verbose_name: "Destinataire",
          val(row) {
            return row.destinataire.nom;
          },
        },
        {
          sort_key: "pays_nom",
          verbose_name: "Pays",
          val(row) {
            return row.pays;
          },
        },
        {
          sort_key: "status",
          verbose_name: "Statut",
          val(row) {
            return row.status;
          },
        },
        {
          verbose_name: "Qté Ouvrages",
          val(row) {
            return `${row.nb_ouvrages}`;
          },
        },
        {
          verbose_name: "Qté PLV",
          val(row) {
            return `${row.nb_plvs}`;
          },
        },
        {
          verbose_name: "Qté totale",
          val(row) {
            return `${row.nb_ouvrages + row.nb_plvs}`;
          },
        },
        {
          sort_key: "date_prepa",
          verbose_name: "Début de prépa",
          val(row) {
            return row.date_prepa;
          },
        },
        {
          sort_key: "date_fin_prepa",
          verbose_name: "Fin de prépa",
          val(row) {
            return row.date_fin_prepa;
          },
        },
        {
          sort_key: "cmd_4d__date_expe",
          verbose_name: "Date de clôture",
          val(row) {
            return row.date_expe;
          },
        },
        {
          verbose_name: "Incoterm",
          val(row) {
            return row.incoterm || "-";
          },
        },
        {
          sort_key: "transport_nom",
          verbose_name: "Transporteur",
          val(row) {
            return row.transport;
          },
        },
      ],
      commentTooltipCache: {},
    };
  },
  computed: {
    ...mapState({
      btLib: (state) => state.booktrackingLibraires || {},
      btAmb: (state) => state.booktrackingAmbassades || {},
      rootSearchText: (state) => state.searchText,
    }),
    isNH() {
      return this.$store.getters.typeUser.nom === "NH";
    },
    parsedItemsLibraires() {
      return this.itemsLibraires.map((item) => ({
        ...item,
        date_commande: formatDateFR(item.date_commande),
        date_prepa: formatDateFR(item.date_prepa),
        date_fin_prepa: formatDateFR(item.date_fin_prepa),
        date_expe: formatDateFR(item.date_expe),
      }));
    },
    parsedItemsAmbassades() {
      return this.itemsAmbassades.map((item) => ({
        ...item,
        date_commande: formatDateFR(item.date_commande),
        date_prepa: formatDateFR(item.date_prepa),
        date_fin_prepa: formatDateFR(item.date_fin_prepa),
        date_expe: formatDateFR(item.date_expe),
      }));
    },
    columnsAmbassades() {
      return this.columns.filter((col) => col.verbose_name !== "Incoterm");
    },
  },
  watch: {
    // Triggered when Search dispatches `${namespace}/fetchData`
    "btLib.refreshIndex": function onBtLibRefresh() {
      this.applySearchToLibraires();
    },
    "btAmb.refreshIndex": function onBtAmbRefresh() {
      this.applySearchToAmbassades();
    },
  },
  mounted() {
    // Allow global search to target these modules while this view is active
    if (this.$store.state.booktrackingLibraires) {
      this.$store.state.booktrackingLibraires.ignoreGlobalSearch = false;
      this.$store.state.booktrackingLibraires.verboseNamespace = "BookTracking - Libraires";
    }
    if (this.$store.state.booktrackingAmbassades) {
      this.$store.state.booktrackingAmbassades.ignoreGlobalSearch = false;
      this.$store.state.booktrackingAmbassades.verboseNamespace = "BookTracking - Ambassades";
    }
  },
  beforeDestroy() {
    if (this.$store.state.booktrackingLibraires) {
      this.$store.state.booktrackingLibraires.ignoreGlobalSearch = true;
    }
    if (this.$store.state.booktrackingAmbassades) {
      this.$store.state.booktrackingAmbassades.ignoreGlobalSearch = true;
    }
  },
  methods: {
    buildFiltersFromSearch(search) {
      const filters = [];
      if (search == null || search === "") return filters;
      if (typeof search !== "object") {
        filters.push({ key: "search", value: search });
        return filters;
      }
      Object.keys(search).forEach((key) => {
        const rawVal = search[key];
        if (rawVal == null || rawVal === "") return;
        const cleanKey = key.replace("__unaccent", "");
        const isBoolean = rawVal === true || rawVal === false || rawVal === "true" || rawVal === "false";
        const paramKey = isBoolean ? cleanKey : `${cleanKey}__icontains`;
        filters.push({ key: paramKey, value: rawVal });
      });
      return filters;
    },
    applySearchToLibraires() {
      // Set page from module state and rebuild filters from root searchText
      const page = (this.btLib && this.btLib.numPageCourante) || 1;
      this.navigationSettingsLibraires.pageActuelle = page;
      this.filtersLibraires = this.buildFiltersFromSearch(this.rootSearchText);
      if (!this.isOpenLibraires) this.isOpenLibraires = true;
      this.loadDataLibraires();
    },
    applySearchToAmbassades() {
      const page = (this.btAmb && this.btAmb.numPageCourante) || 1;
      this.navigationSettingsAmbassades.pageActuelle = page;
      this.filtersAmbassades = this.buildFiltersFromSearch(this.rootSearchText);
      if (!this.isOpenAmbassades) this.isOpenAmbassades = true;
      this.loadDataAmbassades();
    },
    // Libraires
    toggleLibraires() {
      this.isOpenLibraires = !this.isOpenLibraires;
      if (this.isOpenLibraires) {
        // On change le selectedNamespace pour filtrer sur les bonnes colonnes
        this.$store.commit("setNamespaceSearch", Object.keys(this.$store._modulesNamespaceMap).indexOf("booktrackingLibraires/")); // eslint-disable-line
        this.loadDataLibraires();
      }
    },
    loadDataLibraires() {
      this.loadingTableLibraires = true;
      this.itemsLibraires = [];
      this.errorLibraires = null;
      const params = {
        titles: false,
        is_nh: this.isNH,
        libraires: true,
        page: this.navigationSettingsLibraires.pageActuelle || 1,
        limit: this.navigationSettingsLibraires.limiteActuelle || this.itemsPerPageOptions[0],
        order_by: this.orderByLibraires,
        type: "libraire",
      };
      this.filtersLibraires.forEach((filter) => {
        params[filter.key] = filter.value;
      });
      Api().get("commande4d/booktracking", { params }).then((res) => {
        const data = res.data;
        this.itemsLibraires = data.data;
        this.nbPagesTotalLibraires = data.nb_pages;
        this.itemsTotalLibraires = data.nb_items;
      })
        .catch((err) => {
          this.errorLibraires = (err && err.response && err.response.data && err.response.data.message)
            || (err && err.message)
            || "Une erreur est survenue.";
        })
        .finally(() => {
          this.loadingTableLibraires = false;
        });
    },
    updatePaginationLibraires(pagination) {
      if (this.loadingTableLibraires) return;
      this.navigationSettingsLibraires.pageActuelle = pagination.page;
      if (!this.itemsPerPageOptions.includes(pagination.limite)) {
        this.navigationSettingsLibraires.limiteActuelle = this.itemsPerPageOptions[0];
      } else {
        this.navigationSettingsLibraires.limiteActuelle = pagination.limite;
      }
      if (this.$store && this.$store.commit) {
        this.$store.commit("booktrackingLibraires/setNumPageCourante", this.navigationSettingsLibraires.pageActuelle);
      }
      this.loadDataLibraires();
    },
    sortLibraires(key) {
      if (this.loadingTableLibraires) return;
      if (this.orderByLibraires === `-${key}`) {
        this.orderByLibraires = key;
      } else {
        this.orderByLibraires = `-${key}`;
      }
      this.loadDataLibraires();
    },
    // Ambassades
    toggleAmbassades() {
      this.isOpenAmbassades = !this.isOpenAmbassades;
      if (this.isOpenAmbassades) {
        // On change le selectedNamespace pour filtrer sur les bonnes colonnes
        this.$store.commit("setNamespaceSearch", Object.keys(this.$store._modulesNamespaceMap).indexOf("booktrackingAmbassades/")); // eslint-disable-line
        this.loadDataAmbassades();
      }
    },
    loadDataAmbassades() {
      this.loadingTableAmbassades = true;
      this.itemsAmbassades = [];
      this.errorAmbassades = null;
      const params = {
        titles: false,
        is_nh: this.isNH,
        libraires: false,
        page: this.navigationSettingsAmbassades.pageActuelle || 1,
        limit: this.navigationSettingsAmbassades.limiteActuelle || this.itemsPerPageOptions[0],
        order_by: this.orderByAmbassades,
        type: "ambassade",
      };
      this.filtersAmbassades.forEach((filter) => {
        params[filter.key] = filter.value;
      });
      Api().get("commande4d/booktracking", { params }).then((res) => {
        const data = res.data;
        this.itemsAmbassades = data.data;
        this.nbPagesTotalAmbassades = data.nb_pages;
        this.itemsTotalAmbassades = data.nb_items;
      })
        .catch((err) => {
          this.errorAmbassades = (err && err.response && err.response.data && err.response.data.message)
            || (err && err.message)
            || "Une erreur est survenue.";
        })
        .finally(() => {
          this.loadingTableAmbassades = false;
        });
    },
    updatePaginationAmbassades(pagination) {
      if (this.loadingTableAmbassades) return;
      this.navigationSettingsAmbassades.pageActuelle = pagination.page;
      if (!this.itemsPerPageOptions.includes(pagination.limite)) {
        this.navigationSettingsAmbassades.limiteActuelle = this.itemsPerPageOptions[0];
      } else {
        this.navigationSettingsAmbassades.limiteActuelle = pagination.limite;
      }
      if (this.$store && this.$store.commit) {
        this.$store.commit("booktrackingAmbassades/setNumPageCourante", this.navigationSettingsAmbassades.pageActuelle);
      }
      this.loadDataAmbassades();
    },
    sortAmbassades(key) {
      if (this.loadingTableAmbassades) return;
      if (this.orderByAmbassades === `-${key}`) {
        this.orderByAmbassades = key;
      } else {
        this.orderByAmbassades = `-${key}`;
      }
      this.loadDataAmbassades();
    },
    consultButtonId(commande) {
      return `consult-btn-${commande.type || "cmd"}-${commande.id}`;
    },
    commentTooltipKey(commande) {
      return `${commande.type || "unknown"}-${commande.id}`;
    },
    commentTooltipState(commande) {
      const key = this.commentTooltipKey(commande);
      return this.commentTooltipCache[key] || { status: "idle", comments: [], error: null };
    },
    handleCommentTooltipEnter(commande) {
      if (!commande || (commande.commentaires || 0) <= 0) {
        return;
      }
      const state = this.commentTooltipState(commande);
      if (state.status === "idle" || state.status === "error") {
        this.fetchCommentTooltip(commande);
      }
    },
    fetchCommentTooltip(commande) {
      if (!commande || (commande.commentaires || 0) <= 0) {
        return;
      }
      const key = this.commentTooltipKey(commande);
      this.$set(this.commentTooltipCache, key, {
        status: "loading",
        comments: [],
        error: null,
      });
      const params = this.buildCommentTooltipParams(commande);
      if (!params) {
        this.$set(this.commentTooltipCache, key, {
          status: "error",
          comments: [],
          error: "Type de commande inconnu.",
        });
        return;
      }
      Api()
        .get("preparation_commande/", { params })
        .then((res) => {
          const comments = (res && res.data && res.data.results) || [];
          if (!comments.length) {
            return comments;
          }
          const userIds = Array.from(new Set(
            comments
              .map((comment) => comment && comment.user_created)
              .filter((userId) => typeof userId === "number" || typeof userId === "string"),
          ));
          if (!userIds.length) {
            return comments;
          }
          return Promise.all(
            userIds.map((userId) => Api()
              .get(`/user/${userId}/`)
              .then((userRes) => [userId, userRes.data])
              .catch(() => [userId, null])),
          ).then((entries) => {
            const userMap = new Map(entries.filter(([, user]) => user));
            return comments.map((comment) => {
              const user = userMap.get(comment.user_created);
              if (user) {
                comment.user_created = user;
              }
              return comment;
            });
          });
        })
        .then((comments) => {
          const status = comments && comments.length ? "loaded" : "empty";
          this.$set(this.commentTooltipCache, key, {
            status,
            comments: comments || [],
            error: null,
          });
        })
        .catch(() => {
          this.$set(this.commentTooltipCache, key, {
            status: "error",
            comments: [],
            error: "Commentaire indisponible.",
          });
        });
    },
    buildCommentTooltipParams(commande) {
      if (!commande || !commande.id) {
        return null;
      }
      const params = {
        ordering: "-date_creation",
        page_size: commande.commentaires || 20,
      };
      if (commande.type === "libraire") {
        params.commande_libraire = commande.id;
        return params;
      }
      if (commande.type === "ambassade") {
        params.commande_ambassade = commande.id;
        return params;
      }
      return null;
    },
    formatCommentDate(value) {
      if (!value) return null;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;
      const datePart = formatDateFR(date);
      const timePart = date.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      return [datePart, timePart].filter(Boolean).join(" ");
    },
    formatCommentType(typeCommentaire) {
      if (typeCommentaire === "LDE") {
        return "LDE";
      }
      return "ARS";
    },
    commentTypeClass(typeCommentaire) {
      return typeCommentaire === "LDE"
        ? "comment-meta-type--lde"
        : "comment-meta-type--ars";
    },
    // Modal
    openCommande(commande) {
      if (commande.type === "libraire") {
        this.$modal.show("libraire", {
          commandeId: commande.id,
          libraire: commande.destinataire,
        });
      } else if (commande.type === "ambassade") {
        this.$modal.show("ambassade", {
          commandeId: commande.id,
          ambassade: commande.destinataire,
        });
      }
    },
    openComments(commande) {
      this.$modal.show(`comments-${commande.id}`, {
        commandeId: commande.id,
        type: commande.type,
      });
    },
  },
};
</script>

<style lang="scss">
@use "@/components/commandes/booktracking/booktracking.scss";
</style>
